/** Цвета в обоих форматах задаются индексом в палитре или темой с осветлением — сводим всё к hex. */

/** Стандартная 56-цветная палитра Excel: в xls она же используется по умолчанию, в xlsx — для color[indexed]. */
export const INDEXED_PALETTE = [
  '#000000',
  '#FFFFFF',
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FFFF00',
  '#FF00FF',
  '#00FFFF',
  '#000000',
  '#FFFFFF',
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FFFF00',
  '#FF00FF',
  '#00FFFF',
  '#800000',
  '#008000',
  '#000080',
  '#808000',
  '#800080',
  '#008080',
  '#C0C0C0',
  '#808080',
  '#9999FF',
  '#993366',
  '#FFFFCC',
  '#CCFFFF',
  '#660066',
  '#FF8080',
  '#0066CC',
  '#CCCCFF',
  '#000080',
  '#FF00FF',
  '#FFFF00',
  '#00FFFF',
  '#800080',
  '#800000',
  '#008080',
  '#0000FF',
  '#00CCFF',
  '#CCFFFF',
  '#CCFFCC',
  '#FFFF99',
  '#99CCFF',
  '#FF99CC',
  '#CC99FF',
  '#FFCC99',
  '#3366FF',
  '#33CCCC',
  '#99CC00',
  '#FFCC00',
  '#FF9900',
  '#FF6600',
  '#666699',
  '#969696',
  '#003366',
  '#339966',
  '#003300',
  '#333300',
  '#993300',
  '#993366',
  '#333399',
  '#333333',
];

/** 64 и 65 — «автоматические» цвета текста и фона. */
export function indexedColor(index: number, palette: string[] = INDEXED_PALETTE): string | undefined {
  if (index === 64 || index === 65) {
    return undefined;
  }
  return palette[index];
}

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

export function safeColor(value?: string): string | undefined {
  return value && HEX_COLOR.test(value) ? value : undefined;
}

export function rgbToHex(red: number, green: number, blue: number): string {
  const hex = (value: number) => value.toString(16).padStart(2, '0');
  return `#${hex(red)}${hex(green)}${hex(blue)}`;
}

function toRgb(hex: string): [number, number, number] {
  return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
}

/**
 * tint осветляет (>0) или затемняет (<0) цвет темы: работаем по яркости в HSL,
 * как это описано в спецификации OOXML.
 */
export function applyTint(hex: string, tint: number): string {
  if (!tint) {
    return hex;
  }
  const [red, green, blue] = toRgb(hex).map((channel) => channel / 255);
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  let luminance = (max + min) / 2;
  luminance = tint < 0 ? luminance * (1 + tint) : luminance * (1 - tint) + tint;

  const delta = max - min;
  const saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * ((max + min) / 2) - 1));
  let hue = 0;
  if (delta !== 0) {
    if (max === red) {
      hue = ((green - blue) / delta) % 6;
    } else if (max === green) {
      hue = (blue - red) / delta + 2;
    } else {
      hue = (red - green) / delta + 4;
    }
    hue *= 60;
    if (hue < 0) {
      hue += 360;
    }
  }

  const chroma = (1 - Math.abs(2 * luminance - 1)) * saturation;
  const second = chroma * (1 - Math.abs(((hue / 60) % 2) - 1));
  const match = luminance - chroma / 2;
  const sector = Math.floor(hue / 60) % 6;
  const rgb = [
    [chroma, second, 0],
    [second, chroma, 0],
    [0, chroma, second],
    [0, second, chroma],
    [second, 0, chroma],
    [chroma, 0, second],
  ][sector];

  return rgbToHex(...(rgb.map((channel) => Math.round((channel + match) * 255)) as [number, number, number]));
}
